import { gql } from '@apollo/client';
import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import Select from 'react-select';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import '../../../assets/scss/projectTable.scss';
import Filter from '../../components/filter';
import { ReactComponent as Back } from '../../../assets/svg/arrow-back.svg';
import { ReactComponent as Rank } from '../../../assets/svg/rank-icon.svg';
import { ReactComponent as Edit } from '../../../assets/svg/edit-2.svg';
import { ReactComponent as Delete } from '../../../assets/svg/delete-icon.svg';
import _ from 'lodash';
import moment from 'moment';
import {
	AreaChart,
	Area,
	XAxis,
	YAxis,
	CartesianGrid,
	ReferenceLine,
	Tooltip,
	Legend,
	BarChart,
	Bar,
	Line,
	Label,
} from 'recharts';
import LoadingBar from '../../components/global/loadingBar';
import Modal from '../../components/modals';
import UploadLogoForm from '../../components/modals/workspace/logo';
import Dropzone from 'react-dropzone';
import { ReactComponent as UploadIcon } from '../../../assets/svg/upload-cloud.svg';
import AssignAsset from '../../components/modals/projects/assignAsset';
import { TENANT_USER_LOGIN_SIGNUP_API } from '../../../controllers/actionTypes';
var validator = require('validator');
const getProductivity = gql`
	query TenantUserEventActivity($userId: ID!, $startDate: Int!, $endDate: Int!) {
		tenantUserEventActivity(userId: $userId, startDate: $startDate, endDate: $endDate) {
			currentMonth {
				totalEvents
				date
				projectId
			}
			pastMonths {
				totalEvents
				month
			}
			shootDays {
				shootDays
				month
			}
			feedBack {
				totalFeedBacks
				month
			}
			project {
				title
				eventsCount
			}
		}
	}
`;
const deleteAsset = gql`
	mutation RemoveAssetFromEmp($identifier: String!, $employeeId: ID!) {
		removeAssetFromEmp(identifier: $identifier, employeeId: $employeeId) {
			allocatedAt
			branch {
				_id
				branchId
			}
			createdAt
			createdBy
			description
			employees {
				_id
				name
			}
			isAvailable
			id
		}
	}
`;
const getExpenses = gql`
	query TenantUserExpenseActivity($userId: ID!, $startDate: Int!, $endDate: Int!) {
		tenantUserExpenseActivity(userId: $userId, startDate: $startDate, endDate: $endDate) {
			currentMonth {
				totalExpense
				billDate
			}
			pastMonths {
				totalExpense
				month
			}
		}
	}
`;
const getEmployeeDetails = gql`
	query GetEmployee($getEmployeeId: ID!) {
		getEmployee(id: $getEmployeeId) {
			designation
			dp_b2_300w_key
			dp_signed_url
			officePhoneNumber
			tenantUserId
			id

			gender
			fullName
			displayName
			assets {
				_id
				type
			}

			dob
			bloodGroup
			aadharNumber
			panNumber
			officeEmail
			personalEmail
			workspaceId

			employeeType
			department
			monthlySalaryPreTax
			branch {
				branchId
			}
			status
			joiningDate
			personalPhoneNumber
			currentAddress {
				street
				city
				country
				district
				pinCode
				state
			}
			bankAccountDetails {
				IFSC
				accountNumber
				bankName
				branch
			}
			permanentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			emergencyContact {
				name
				phoneNumber
			}
		}
	}
`;
const getEmployeeDetails2 = gql`
	query GetEmployee($getEmployeeId: ID!) {
		getEmployee(id: $getEmployeeId) {
			id
			aadharNumber
			employeeId
			dp_b2_300w_key
			dp_signed_url
			assets {
				_id
				type
				serialNumber
				qrCode
			}
			displayName
			bankAccountDetails {
				IFSC
				accountNumber
				accountHolderName
				bankName
				branch
			}
			bloodGroup
			branch {
				_id
				branchId
			}
			createdAt
			createdBy
			currentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			deletedAt
			deletedBy
			department
			designation
			dob
			emergencyContact {
				name
				phoneNumber
				relation
			}
			employeeType

			fullName
			gender
			id
			isDeleted
			joiningDate

			monthlySalaryPreTax
			officeEmail
			officePhoneNumber
			panNumber
			permanentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			personalEmail
			personalPhoneNumber
			status
			updatedAt
			updatedBy
			workspaceId
		}
	}
`;
const getRank = gql`
	query ShooterRank($userId: ID!) {
		shooterRank(userId: $userId) {
			rank
		}
	}
`;
const getWorkSpaceOptions = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			associatedTenants {
				workspaceId
			}
		}
	}
`;
const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;
const getEmployeeDefaultfilters = gql`
	query EmployeeDefaultfilters {
		employeeDefaultfilters {
			designation
			department
			workspaceId
		}
	}
`;
const editEmployee = gql`
	mutation UpdateEmployee($updateEmployeeId: ID!, $updateEmployeeInput: UpdateEmployeeInput) {
		updateEmployee(id: $updateEmployeeId, updateEmployeeInput: $updateEmployeeInput) {
			gender
			dob
			bloodGroup
			aadharNumber
			panNumber
			joiningDate
			employeeType
			workspaceId
			department
			designation
			monthlySalaryPreTax
			branch {
				branchId
				_id
			}
			status
			personalEmail
			personalPhoneNumber
			officeEmail
			officePhoneNumber
			currentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			permanentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			emergencyContact {
				phoneNumber
				relation
				name
			}
			bankAccountDetails {
				IFSC
				accountNumber
			}
			createdAt
			createdBy
			deletedAt
			deletedBy
			id
			isDeleted
			fullName
			updatedAt
			updatedBy
		}
	}
`;
class EmployeeDetails extends ProjectsGraphQl {
	constructor() {
		super();
		const currentYear = moment().year();
		const currentMonth = moment().month();
		const startDate = moment().set({ year: currentYear, month: currentMonth });

		const monthOptions = [];
		let currentDate = startDate.clone();

		while (currentDate.isSameOrAfter(moment('2022-01-01'))) {
			monthOptions.push({
				key: currentDate.format('YYYYMM'),
				name: currentDate.format('MMM YYYY'),
			});
			currentDate.subtract(1, 'month');
		}
		this.state = {
			employeeDetails: {},
			empId: null,
			imageSrc: null,
			monthOptions,
			monthActiveFilter: moment().startOf('month').format('YYYYMM'),
			showUploadLogoModal: false,
			croppedFile: null,
			showEmployeeDetails: true,
			showEmployment: false,
			showContact: false,
			showProductivity: false,
			assets: [],
			employeeExpenseDetails: null,

			showBank: false,
			userProductivityDetails: null,
			message: '',
			employeeId: '',
			employeeId2: '',
			workspaceOptions: [],
			empTypeOptions: [
				{ value: 'SALARIED', label: 'Salaried' },
				{ value: 'CONSULTANT', label: 'Consultant' },
				{ value: 'INTERN', label: 'Intern' },
			],

			genderOptions: [
				{ value: 'MALE', label: 'Male' },
				{ value: 'FEMALE', label: 'Female' },
				{ value: 'OTHER', label: 'Other' },
			],
			employeeType: '',
			genderType: '',
			designations: [],
			departments: [],
			showAssetModal: false,
			employeeType: null,
			selectedBloodGroup: '',
			bloodGroupOptions: [
				{
					label: 'A+',
					value: 'A+',
				},
				{
					label: 'A-',
					value: 'A-',
				},
				{
					label: 'B+',
					value: 'B+',
				},
				{
					label: 'B-',
					value: 'B-',
				},
				{
					label: 'AB+',
					value: 'AB+',
				},
				{
					label: 'AB-',
					value: 'AB-',
				},
				{
					label: 'O+',
					value: 'O+',
				},
				{
					label: 'O-',
					value: 'O-',
				},
			],
			branchesOptions: [],
			selectedBranch: '',
			selectedDepartment: '',
			selectedDesignation: '',
			branchId: '',
			selectedDob: '',
			selectedJoiningDate: '',
			fnError: false,
			lnError: false,
			adError: false,
			panerror: false,
			curcityEr: false,
			curcountryEr: false,
			curDistrictEr: false,
			curPcEr: false,
			curStateEr: false,
			curStreetEr: false,
			percityEr: false,
			percountryEr: false,
			perDistrictEr: false,
			isemployeeloading: true,
			perPcEr: false,
			perStateEr: false,
			perStreetEr: false,
			emergencyNameError: false,
			bankifscEr: false,
			bankAccHolErr: false,
			bankAccNumberError: false,
			bankBranchError: false,
			bankNameError: false,

			selectedBrand: '',
			brandString: '',
			branchIdString: '',
			statusOptions: [
				{ value: 'ACTIVE', label: 'Active' },
				{ value: 'TERMINATED', label: 'Terminated' },
				{ value: 'ON_HOLD', label: 'On Hold' },
			],
			selectedStatus: '',
			statusString: null,
			firstName: null,
			lastName: null,
			gender: null,
			dob: null,

			bloodGroup: null,
			// croppedFile: null,
			aadharNumber: null,
			panNumber: null,
			joiningDate: null,
			department: null,
			designation: null,
			monthlySalaryPreTax: null,
			personalPhoneNumber: null,
			personalEmail: null,
			officeEmail: null,
			startDate: moment().clone().startOf('month').format('YYYYMMDD'),
			endDate: moment().clone().endOf('month').format('YYYYMMDD'),
			officePhoneNumber: null,
			currentAddress: {
				city: null,
				country: null,
				district: null,
				pinCode: null,
				state: null,
				street: null,
			},
			permanentAddress: {
				city: null,
				country: null,
				district: null,
				pinCode: null,
				state: null,
				street: null,
			},
			emergencyContact: {
				name: null,
				phoneNumber: null,
				relation: null,
			},
			bankAccountDetails: {
				IFSC: null,
				accountHolderName: null,
				accountNumber: null,
				branch: null,
				bankName: null,
			},

			fullName: null,
			displayName: null,
			showAsset: false,
			isAPISubmitting: false,
			officeEmailError: false,
			personalEmailError: false,
			personalPhoneNumberError: false,
			officePhoneNumberError: false,
			emergencyContactError: false,
			editButtonClk: false,
			isemployeedetails2loading: true,
			assetTypeOptions: [
				{ label: 'Keyboard', value: 'keyboard' },
				{ label: 'Mouse', value: 'mouse' },
				{ label: 'Memory Card Reader', value: 'memoryCardReader' },
				{ label: 'Hub', value: 'hub' },
				{ label: 'iMac', value: 'iMac' },
				{ label: 'MacBook', value: 'macbook' },
				{ label: 'Mobile Phone', value: 'mobilePhone' },
				{ label: 'Sim', value: 'sim' },
				{ label: 'Monitor', value: 'monitor' },
				{ label: 'CPU', value: 'CPU' },
				{ label: 'Headphone', value: 'headphone' },
				{ label: 'Adapter', value: 'adapter' },
				{ label: 'Chair', value: 'chair' },
				{ label: 'Laptop', value: 'laptop' },
			],
		};
	}
	componentDidMount = async () => {
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0] && subString[0] === 'activeTab' && subString[1] === 'asset') {
					this.setState({
						showAsset: true,
					});
					this.setState({
						showEmployment: false,
						showContact: false,
						showEmployeeDetails: false,
						showBank: false,
						editButtonClk: false,
					});
				} else if (
					subString[0] &&
					subString[0] === 'activeTab' &&
					subString[1] === 'productivity'
				) {
					this.setState({
						showProductivity: true,
					});
					this.setState({
						showEmployment: false,
						showContact: false,
						showEmployeeDetails: false,
						showBank: false,
						editButtonClk: false,
						showAsset: false,
					});
				} else if (subString[0] && subString[0] === 'monthActiveFilter') {
					this.setState({
						[subString[0]]: subString[1],
						startDate: moment(subString[1]).startOf('month').format('YYYYMMDD'),
						endDate: moment(subString[1]).endOf('month').format('YYYYMMDD'),
					});
				} else if (
					subString[0] &&
					subString[0] === 'activeTab' &&
					subString[1] === 'bank'
				) {
					this.setState({
						showBank: true,
					});
					this.setState({
						showEmployment: false,
						showContact: false,
						showEmployeeDetails: false,
						editButtonClk: false,
						showAsset: false,
					});
				} else if (
					subString[0] &&
					subString[0] === 'activeTab' &&
					subString[1] === 'contact'
				) {
					this.setState({
						showContact: true,
					});
					this.setState({
						showEmployment: false,
						showEmployeeDetails: false,
						showBank: false,
						editButtonClk: false,
						showAsset: false,
					});
				} else if (
					subString[0] &&
					subString[0] === 'activeTab' &&
					subString[1] === 'employment'
				) {
					this.setState({
						showEmployment: true,
					});
					this.setState({
						showEmployeeDetails: false,
						showContact: false,
						showBank: false,
						editButtonClk: false,
						showAsset: false,
					});
				} else {
					this.setState({
						showEmployeeDetails: true,
					});
					this.setState({
						showEmployment: false,
						showContact: false,
						showBank: false,
						editButtonClk: false,
						showAsset: false,
					});
				}

				count++;
			}
		}
		let json = {
			getEmployeeId: this.props.params.employeeId,
		};
		const json2 = {
			vendorId: this.props.params.vendorID,
		};
		// let json3 = {
		// 	userId: this.props.params.employeeId,
		// 	// userId: '6384a5128e31f7db19295a43',
		// 	// startDate: 20230601,
		// 	// endDate: 20230630,
		// 	startDate: parseInt(this.state.startDate),
		// 	endDate: parseInt(this.state.endDate),
		// };

		await this.getEmployeeDetails(getEmployeeDetails, json);
		await this.getEmployeeDetails2(getEmployeeDetails2, json);
		this.getBranchList2(getBranchList);
		this.getEmployeeDefaultfilters(getEmployeeDefaultfilters);
		this.getWorkSpaceOptions(getWorkSpaceOptions, json2);
		let json3 = {
			userId: this.state.employeeDetails.tenantUserId,
			// userId: '6384a5128e31f7db19295a43',
			// startDate: 20230601,
			// endDate: 20230630,
			startDate: parseInt(this.state.startDate),
			endDate: parseInt(this.state.endDate),
		};
		this.getProductivity(getProductivity, json3);
		this.getExpensesNew(getExpenses, json3);
		this.getRank(getRank, { userId: this.state.employeeDetails.tenantUserId });
	};
	handleOnChange = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		let regex = /^[0-9\b]+$/;
		console.log(regex.test(value));
		this.setState({
			[name]: regex.test(value) ? value : '',
		});
	};
	applyFilter = (filter, type) => {
		console.log('checking for filters', filter);
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				startDate: moment(filter).startOf('month').format('YYYYMMDD'),
				endDate: moment(filter).endOf('month').format('YYYYMMDD'),
			},
			() => {
				this.fetchProductivity();
			},
		);
	};
	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: moment().clone().startOf('month').format('YYYYMM'),
				startDate: moment().clone().startOf('month').format('YYYYMMDD'),
				endDate: moment().clone().endOf('month').format('YYYYMMDD'),
			},
			() => this.fetchProductivity(),
		);
	};
	fetchProductivity = () => {
		let queryString = `?activeTab=productivity&monthActiveFilter=${this.state.monthActiveFilter}`;
		this.props.navigate(
			`/${this.props.params.vendorID}/hr/${this.props.params.employeeId}${queryString}`,
		);
		let json3 = {
			userId: this.state.employeeDetails.tenantUserId,
			// userId: '6384a5128e31f7db19295a43',
			// startDate: 20230601,
			// endDate: 20230630,
			startDate: parseInt(this.state.startDate),
			endDate: parseInt(this.state.endDate),
		};
		this.getProductivity(getProductivity, json3).then(() => {
			this.getExpensesNew(getExpenses, json3).then(() => {
				window.location.reload();
			});
		});
		// this.getExpensesNew(getExpenses, json3);
	};
	deleteAssetAPICall = async (asset) => {
		if (this.state.isAPISubmitting === false) {
			this.setState(
				{
					isAPISubmitting: true,
				},
				() => {
					console.log('asset id', asset);
					let json = {
						identifier: asset,
						employeeId: this.state.employeeId,
					};

					this.deleteAsset(deleteAsset, json).then(() => {
						window.location.reload();
					});
					// this.props.navigate(`/${this.props.params.vendorID}/harddrives/assign`);
				},
			);
		}
	};
	generateRandomColor = () => {
		const letters = '0123456789ABCDEF';
		let color = '#';
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	};
	checkUploadLogo = async (files) => {
		const maxSize = 2 * 1024 * 1024; // 2MB
		if (files[0].type !== 'image/jpeg') {
			alert('File type not allowed. Please choose JPEG/JPG format.');
			return;
		}
		if (files[0].size > maxSize) {
			alert(
				'File size exceeds the maximum allowed limit (2MB). Please choose a smaller file.',
			);
			return;
		}
		const reader = new FileReader();
		reader.onload = (e) => {
			this.setState({
				imageSrc: reader.result,

				showUploadLogoModal: true,
				files: files[0],
			});
		};
		reader.readAsDataURL(files[0]);
	};
	showUploadLogoModal = (e) => {
		this.setState({
			showUploadLogoModal: !this.state.showUploadLogoModal,
		});
	};
	onLogoUpdated = () => {
		this.setState({
			showUploadLogoModal: false,
			isLoading: true,
		});
		this.getTenantSettings();
	};
	imgCrop = (img) => {
		this.setState(
			{
				croppedFile: img,
				// imageSrc: img,
			},
			() => {
				const reader = new FileReader();
				reader.onload = (e) => {
					this.setState({
						imageSrc: reader.result,
					});
					this.uploadProfilePicture(this.state.croppedFile, this.state.employeeId);
				};
				reader.readAsDataURL(img);
			},
		);
	};
	editEmployeeAPICall = () => {
		if (this.state.showEmployeeDetails) {
			if (this.state.isAPISubmitting === false) {
				this.setState(
					{
						isAPISubmitting: true,
					},
					() => {
						let updateEmployeeInput = {};
						let arr = [
							'displayName',
							'fullName',
							'gender',
							'dob',
							'bloodGroup',
							'aadharNumber',
							'employeeId2',
							'panNumber',
						];
						_.map(arr, (item, key) => {
							if (
								this.state[item] !==
									this.state[
										'prev' + [item][0].toUpperCase() + [item].slice(1)
									] &&
								this.state[item] !== null
							) {
								if (item === 'employeeId2') {
									updateEmployeeInput = {
										...updateEmployeeInput,
										employeeId: this.state.employeeId2,
									};
								} else {
									updateEmployeeInput = {
										...updateEmployeeInput,
										[item]: this.state[item],
									};
								}
							}
						});
						let json = {
							updateEmployeeId: this.props.params.employeeId,
							updateEmployeeInput: updateEmployeeInput,
						};

						this.editEmployee(editEmployee, json).then(() => {
							window.location.reload();
						});

						// this.props.navigate(`/${this.props.params.vendorID}/harddrives/assign`);
					},
				);
			}
		}
		if (this.state.showEmployment) {
			if (this.state.isAPISubmitting === false) {
				this.setState(
					{
						isAPISubmitting: true,
					},
					() => {
						let updateEmployeeInput = {};
						let arr = [
							'joiningDate',
							'employeeType',
							'workspaceId',
							'department',
							'designation',
							'status',
							'monthlySalaryPreTax',
							'branch',
						];
						_.map(arr, (item, key) => {
							if (item === 'status') {
								updateEmployeeInput = {
									...updateEmployeeInput,
									[item]: this.state.statusString,
								};
							}
							if (item === 'workspaceId') {
								updateEmployeeInput = {
									...updateEmployeeInput,
									[item]: this.state.brandString,
								};
							}
							if (item === 'branch') {
								updateEmployeeInput = {
									...updateEmployeeInput,
									[item]: {
										_id: this.state.branchId,
										branchId: this.state.branchIdString,
									},
								};
							}
							console.log(
								item,
								this.state[item] !==
									this.state[
										'prev' + [item][0].toUpperCase() + [item].slice(1)
									] && this.state[item] !== null,
							);
							if (
								this.state[item] !==
									this.state[
										'prev' + [item][0].toUpperCase() + [item].slice(1)
									] &&
								this.state[item] !== null
							) {
								updateEmployeeInput = {
									...updateEmployeeInput,
									[item]:
										item === 'monthlySalaryPreTax'
											? parseFloat(this.state[item])
											: this.state[item],
								};
							}
						});

						let json = {
							updateEmployeeId: this.props.params.employeeId,

							updateEmployeeInput: updateEmployeeInput,
						};

						this.editEmployee(editEmployee, json).then(() => {
							window.location.reload();
						});
					},
				);
			}
		}
		if (this.state.showContact) {
			if (this.state.isAPISubmitting === false) {
				this.setState(
					{
						isAPISubmitting: true,
					},
					() => {
						let updateEmployeeInput = {};
						let arr = [
							'personalPhoneNumber',
							'personalEmail',
							'officeEmail',
							'officePhoneNumber',
							'emergencyContact',
							'currentAddress',
							'permanentAddress',
						];
						_.map(arr, (item, key) => {
							if (
								this.state[item] !==
									this.state[
										'prev' + [item][0].toUpperCase() + [item].slice(1)
									] &&
								this.state[item] !== null
							) {
								if (item === 'emergencyContact') {
									updateEmployeeInput = {
										...updateEmployeeInput,
										[item]: {
											...this.state[item],
											name: this.state[item].name,
											phoneNumber: '+91' + this.state[item].phoneNumber,
											relation: this.state[item].relation,
										},
									};
								} else {
									updateEmployeeInput = {
										...updateEmployeeInput,
										[item]:
											item === 'personalPhoneNumber' ||
											item === 'officePhoneNumber'
												? '+91' + this.state[item]
												: this.state[item],
									};
								}
							}
						});
						let json = {
							updateEmployeeId: this.props.params.employeeId,

							updateEmployeeInput: updateEmployeeInput,
						};

						this.editEmployee(editEmployee, json).then(() => {
							window.location.reload();
						});

						// this.props.navigate(`/${this.props.params.vendorID}/harddrives/assign`);
					},
				);
			}
		}
		if (this.state.showBank) {
			if (this.state.isAPISubmitting === false) {
				this.setState(
					{
						isAPISubmitting: true,
					},
					() => {
						let updateEmployeeInput = {};
						let arr = ['bankAccountDetails'];
						_.map(arr, (item, key) => {
							if (
								this.state[item] !==
									this.state[
										'prev' + [item][0].toUpperCase() + [item].slice(1)
									] &&
								this.state[item] !== null
							) {
								updateEmployeeInput = {
									...updateEmployeeInput,
									[item]: this.state[item],
								};
							}
						});
						let json = {
							updateEmployeeId: this.props.params.employeeId,
							updateEmployeeInput: updateEmployeeInput,
						};

						this.editEmployee(editEmployee, json).then(() => {
							window.location.reload();
						});
					},
				);
			}
		}
	};
	toggleAssignAsset = () => {
		this.setState({
			showAssetModal: true,
		});
	};
	render() {
		return (
			<div>
				<div className="layout-wrapper">
					{this.state.isemployeedetails2loading ? (
						<>
							<LoadingBar />
						</>
					) : (
						<div className="container">
							<div className="searchContainer">
								<a
									className="title"
									style={{
										color: '#B0B0B0',
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<Back
										style={{
											cursor: 'pointer',
											height: '24px',
											width: '24px',
										}}
										onClick={() => {
											this.props.navigate(
												`/${this.props.params.vendorID}/hr`,
											);
										}}
									/>
									<span
										style={{
											marginLeft: '30px',
											fontSize: '24px',
											fontWeight: '500',
											color: '#DBDBDB',
										}}
									>
										{this.state.employeeDetails.fullName}
									</span>
								</a>
							</div>
							<div
								style={{
									position: 'relative',
									top: '80px',
									width: '100%',
									left: '0px',
									padding: '0px 24px',
								}}
							>
								<div
									style={{
										width: '95%',
										display: 'flex',
										justifyContent: 'space-between',
									}}
								>
									<div
										style={{
											width: '25%',
											display: 'flex',
											flexDirection: 'column',
											gap: '8px',
											marginTop: '10px',
										}}
									>
										<Dropzone
											onDrop={this.checkUploadLogo.bind(this)}
											accept={'image/jpeg'}
											multiple={false}
											// disabled={this.state.addEmployeeId.length === 0}
										>
											{({ getRootProps, getInputProps }) => (
												<div
													className="upload-brand-embeded-btn"
													{...getRootProps({})}
												>
													<input {...getInputProps()} />
													<div className="upload-brand-container-new">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																alignItems: 'center',
																justifyContent: 'center',
																margin: 0,
															}}
															className="upload-container f-left"
														>
															{this.state.imageSrc ? (
																<img
																	src={this.state.imageSrc}
																	style={{
																		width: '100%',
																		maxHeight: '100%',
																		objectFit: 'contain',
																	}}
																/>
															) : (
																<div className="upload-empty-text">
																	No Profile Picture selected
																</div>
															)}
														</div>
														<div className="upload">
															<span className="upload-icon">
																<UploadIcon />
															</span>
															<span className="upload-text">
																Edit Profile Picture
															</span>
														</div>
													</div>
												</div>
											)}
										</Dropzone>

										<div
											className="emp-det-style"
											style={{
												width: '100%',
												backgroundColor: 'rgba(42, 42, 42, 0.5)',
												padding: '30px 13px',
												display: 'flex',
												flexDirection: 'column',

												// justifyContent: 'space-between',
												gap: '20px',
												// color: 'white',
											}}
										>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Display Name*</p>
												<p className="emp-det-row-second">
													{this.state.employeeDetails.displayName}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Designation</p>
												<p className="emp-det-row-second">
													{this.state.employeeDetails.designation
														? this.state.employeeDetails.designation
																.replace(/([a-z])([A-Z])/g, '$1 $2')
																.replace(/(?:^|\s)\S/g, (a) =>
																	a.toUpperCase(),
																)
														: ''}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">
													Office Phone and Email
												</p>
												<p
													className="emp-det-row-second"
													style={{
														marginBottom: '5px',
													}}
												>
													{this.state.employeeDetails.officePhoneNumber !=
													'+91'
														? this.state.employeeDetails
																.officePhoneNumber
														: '-'}
												</p>
												<p
													className="emp-det-row-second"
													style={{
														textTransform: 'none',
													}}
												>
													{this.state.employeeDetails.officeEmail
														? this.state.employeeDetails.officeEmail
														: '-'}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">
													Personal Phone and Email
												</p>
												<p
													className="emp-det-row-second"
													style={{
														marginBottom: '5px',
													}}
												>
													{this.state.employeeDetails.personalPhoneNumber}
												</p>
												<p
													className="emp-det-row-second"
													style={{
														textTransform: 'none',
													}}
												>
													{this.state.employeeDetails.personalEmail}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Department</p>
												<p className="emp-det-row-second">
													{this.state.employeeDetails.department}
												</p>
											</div>
											<div className="emp-det-row">
												<p className="emp-det-row-first">Brand</p>
												<p className="emp-det-row-second">
													{this.state.employeeDetails.workspaceId}
												</p>
											</div>
										</div>
									</div>
									<div
										style={{
											width: '65%',
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<div className="emp-det-head-sec">
											<p
												className="head-p"
												style={{
													borderBottom: this.state.showEmployeeDetails
														? '1.5px solid #8F56DA'
														: '',
													paddingBottom: '5px',
												}}
												onClick={() => {
													let queryString = '?activeTab=employeeDetails';
													this.props.navigate(
														`/${this.props.params.vendorID}/hr/${this.props.params.employeeId}${queryString}`,
													);

													this.setState({
														showEmployeeDetails: true,
													});
													this.setState({
														showEmployment: false,
														showContact: false,
														showBank: false,
														editButtonClk: false,
														showAsset: false,
														showProductivity: false,
													});
												}}
											>
												Employee Details
											</p>
											<p
												className="head-p"
												style={{
													borderBottom: this.state.showEmployment
														? '1.5px solid #8F56DA'
														: '',
													paddingBottom: '5px',
												}}
												onClick={() => {
													let queryString = '?activeTab=employment';
													this.props.navigate(
														`/${this.props.params.vendorID}/hr/${this.props.params.employeeId}${queryString}`,
													);
													this.setState({
														showEmployment: true,
													});
													this.setState({
														showEmployeeDetails: false,
														showContact: false,
														showBank: false,
														editButtonClk: false,
														showAsset: false,
														showProductivity: false,
													});
												}}
											>
												Employment
											</p>
											<p
												className="head-p"
												style={{
													borderBottom: this.state.showContact
														? '1.5px solid #8F56DA'
														: '',
													paddingBottom: '5px',
												}}
												onClick={() => {
													let queryString = '?activeTab=contact';
													this.props.navigate(
														`/${this.props.params.vendorID}/hr/${this.props.params.employeeId}${queryString}`,
													);
													this.setState({
														showContact: true,
													});
													this.setState({
														showEmployment: false,
														showEmployeeDetails: false,
														showBank: false,
														editButtonClk: false,
														showAsset: false,
														showProductivity: false,
													});
												}}
											>
												Contact
											</p>
											<p
												className="head-p"
												style={{
													borderBottom: this.state.showBank
														? '1.5px solid #8F56DA'
														: '',
													paddingBottom: '5px',
												}}
												onClick={() => {
													let queryString = '?activeTab=bank';
													this.props.navigate(
														`/${this.props.params.vendorID}/hr/${this.props.params.employeeId}${queryString}`,
													);
													this.setState({
														showBank: true,
													});
													this.setState({
														showEmployment: false,
														showContact: false,
														showEmployeeDetails: false,
														editButtonClk: false,
														showAsset: false,
														showProductivity: false,
													});
												}}
											>
												Bank
											</p>
											<p
												className="head-p"
												style={{
													borderBottom: this.state.showAsset
														? '1.5px solid #8F56DA'
														: '',
													paddingBottom: '5px',
												}}
												onClick={() => {
													let queryString = '?activeTab=asset';
													this.props.navigate(
														`/${this.props.params.vendorID}/hr/${this.props.params.employeeId}${queryString}`,
													);
													this.setState({
														showAsset: true,
													});
													this.setState({
														showEmployment: false,
														showContact: false,
														showEmployeeDetails: false,
														showBank: false,
														editButtonClk: false,
														showProductivity: false,
													});
												}}
											>
												Asset{' '}
											</p>
											<p
												className="head-p"
												style={{
													borderBottom: this.state.showProductivity
														? '1.5px solid #8F56DA'
														: '',
													paddingBottom: '5px',
												}}
												onClick={() => {
													let queryString = `?activeTab=productivity&monthActiveFilter=${this.state.monthActiveFilter}`;
													this.props.navigate(
														`/${this.props.params.vendorID}/hr/${this.props.params.employeeId}${queryString}`,
													);
													this.setState({
														showProductivity: true,
													});
													this.setState({
														showEmployment: false,
														showContact: false,
														showEmployeeDetails: false,
														showBank: false,
														editButtonClk: false,
														showAsset: false,
													});
												}}
											>
												Productivity{' '}
											</p>
										</div>
										<div
											style={{
												backgroundColor: '#1D1D1D',
												//borderRadius: '6px',
												marginTop: '44px',
												height: '58px',
												display: 'flex',
												alignItems: 'center',
												width: '100%',
												background: '#1D1D1D',
												padding: '0px 15px',
												justifyContent: 'space-between',
											}}
										>
											<p
												style={{
													fontWeight: '400',
													fontSize: '18px',
													marginTop: '9px',
													color: '#FFFFFF',
												}}
											>
												{this.state.showEmployeeDetails ? (
													'Employee Details'
												) : this.state.showEmployment ? (
													'Employment'
												) : this.state.showContact ? (
													'Contact'
												) : this.state.showBank ? (
													'Bank'
												) : this.state.showAsset ? (
													'Asset'
												) : (
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '8px',
														}}
													>
														<Rank />
														<p>
															{' '}
															Overall Rank{' '}
															{this.state.rank === 0
																? '-'
																: this.state.rank}
															{/* Productivity */}
															<span
																style={{
																	color: '#7A7A7A',
																	fontSize: '',
																}}
															></span>
														</p>
													</div>
												)}
												{this.state.showAsset
													? this.state.assets &&
													  this.state.assets.length > 0
														? '(' + this.state.assets.length + ')'
														: '(0)'
													: ''}
											</p>
											{this.state.editButtonClk === false &&
											this.state.showAsset === false &&
											this.state.showProductivity === false ? (
												<Edit
													style={{ cursor: 'pointer' }}
													onClick={() => {
														this.setState({
															editButtonClk:
																!this.state.editButtonClk,
														});
													}}
												/>
											) : (
												''
											)}
											{(this.state.editButtonClk &&
												this.state.showEmployeeDetails) ||
											(this.state.editButtonClk &&
												this.state.showEmployment) ||
											(this.state.editButtonClk && this.state.showContact) ||
											(this.state.editButtonClk && this.state.showBank) ? (
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '5px',
													}}
												>
													<div
														className={'create-shoot-btn2'}
														style={{
															marginRight: '10px',
															border: '0.4px solid #B4B4B4',
															// backgroundColor: '#000000',
														}}
														onClick={() => {
															if (this.state.showEmployeeDetails) {
																this.setState({
																	editButtonClk:
																		!this.state.editButtonClk,
																	displayName:
																		this.state.prevDisplayName,
																	fullName:
																		this.state.prevFullName,
																	dob: this.state.prevDob,
																	selectedDob:
																		this.state.prevSelectedDob,
																	gender: this.state.prevGender,
																	genderType:
																		this.state.prevGenderType,
																	employeeId2:
																		this.state.prevEmployeeId2,
																	aadharNumber:
																		this.state.prevAadharNumber,
																	panNumber:
																		this.state.prevPanNumber,
																	bloodGroup:
																		this.state.prevBloodGroup,
																	selectedBloodGroup:
																		this.state
																			.prevSelectedBloodGroup,
																});
															}
															if (this.state.showEmployment) {
																this.setState({
																	editButtonClk:
																		!this.state.editButtonClk,
																	joiningDate:
																		this.state.prevJoiningDate,
																	selectedJoiningDate:
																		this.state
																			.prevSelectedJoiningDate,
																	employeeTypeSelect:
																		this.state
																			.prevEmployeeTypeSelect,
																	employeeType:
																		this.state.prevEmployeeType,
																	selectedBrand:
																		this.state
																			.prevSelectedBrand,
																	brandString:
																		this.state.prevBrandString,
																	selectedBrandString:
																		this.state
																			.prevSelectedBrandString,
																	designation:
																		this.state.prevDesignation,
																	monthlySalaryPreTax:
																		this.state
																			.prevMonthlySalaryPreTax,
																	selectedBranch:
																		this.state
																			.prevSelectedBranch,
																	branchIdString:
																		this.state
																			.prevBranchIdString,
																	branchId:
																		this.state.prevBranchId,
																	selectedStatus:
																		this.state
																			.prevSelectedStatus,
																	statusString:
																		this.state.prevStatusString,
																	selectedDesignation:
																		this.state
																			.prevSelectedDesignation,
																	selectedDepartment:
																		this.state
																			.prevSelectedDepartment,
																});
															}
															if (this.state.showContact) {
																this.setState({
																	editButtonClk:
																		!this.state.editButtonClk,
																	personalPhoneNumber:
																		this.state
																			.prevPersonalPhoneNumber,
																	personalEmail:
																		this.state
																			.prevPersonalEmail,
																	officeEmail:
																		this.state.prevOfficeEmail,
																	officePhoneNumber:
																		this.state
																			.prevOfficePhoneNumber,
																	emergencyContact: {
																		...this.state
																			.emergencyContact,
																		phoneNumber:
																			this.state
																				.prevEmergencyContact
																				.phoneNumber,
																	},
																	currentAddress:
																		this.state
																			.prevCurrentAddress,
																	permanentAddress:
																		this.state
																			.prevPermanentAddress,
																});
															}
															if (this.state.showBank) {
																this.setState({
																	editButtonClk:
																		!this.state.editButtonClk,
																	bankAccountDetails: {
																		...this.state
																			.bankAccountDetails,
																		IFSC: this.state
																			.prevBankAccountDetails
																			.IFSC,
																		accountHolderName:
																			this.state
																				.prevBankAccountDetails
																				.accountHolderName,
																		accountNumber:
																			this.state
																				.prevBankAccountDetails
																				.accountNumber,
																	},
																});
															}
														}}
													>
														Cancel
													</div>
													<div
														className="create-shoot-btn"
														onClick={() => {
															this.editEmployeeAPICall();
															// window.location.reload();
														}}
													>
														Save
													</div>
												</div>
											) : (
												''
											)}
											{this.state.showAsset ? (
												<div
													className="create-shoot-btn"
													onClick={() => {
														this.toggleAssignAsset();
													}}
												>
													+ Assign Asset
												</div>
											) : (
												''
											)}
											{this.state.showProductivity ? (
												<div className="shoots-header-filters-container">
													<Filter
														type={'month'}
														label={'Month'}
														version="v2"
														filters={this.state.monthOptions}
														activeFilter={this.state.monthActiveFilter}
														clearSelection={(e) =>
															this.handleclearSelection(e, 'month')
														}
														isMultipleSelectable={false}
														filterType="shoot"
														applyFilter={this.applyFilter}
													/>
												</div>
											) : (
												''
											)}
										</div>

										<div
											style={{
												width: '100%',
												padding: '31px 24px',
												background: '#000000',
												height: this.state.showProductivity ? '1200px' : '',
											}}
										>
											{this.state.showProductivity &&
												this.state.shootsGraphData &&
												this.state.shoootDaysGraphData &&
												this.state.currentMonthShootData &&
												this.state.feedBackGraphData && (
													<>
														<div className="prod-upper-graph-section">
															<div className="left-graph-section">
																<div className="proposal-graphs5">
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '15px',
																		}}
																	>
																		<div
																			style={{
																				display: 'flex',
																				flexDirection:
																					'column',
																				gap: '16px',
																			}}
																		>
																			<p
																				style={{
																					color: 'white',

																					fontSize:
																						'12px',
																					fontWeight:
																						'400',
																				}}
																			>
																				Shoots
																			</p>

																			<p className="graph-text">
																				{_.sum(
																					this.state.shootsGraphData.map(
																						(item) =>
																							item.totalEvents,
																					),
																				)}
																			</p>
																		</div>

																		<div className="pg-left">
																			<AreaChart
																				syncId="anyId"
																				width={
																					window.innerWidth /
																						3 -
																					165
																				}
																				height={120}
																				data={this.state.shootsGraphData.map(
																					(obj) => ({
																						...obj,
																						date: moment(
																							obj.month,
																							'YYYYMM',
																						).format(
																							'MMM YY',
																						),
																					}),
																				)}
																				margin={{
																					top: 10,
																					right: 30,
																					left: 0,
																					bottom: 0,
																				}}
																			>
																				<defs>
																					<linearGradient
																						id="colorUv2"
																						x1="0"
																						y1="0"
																						x2="0"
																						y2="1"
																					>
																						<stop
																							offset="5%"
																							stopColor={
																								this
																									.state
																									.shootsGraphData[0]
																									.totalEvents >=
																								this
																									.state
																									.shootsGraphData[2]
																									.totalEvents
																									? '#B83D44'
																									: '#559F7B'
																							}
																							stopOpacity={
																								0.8
																							}
																						/>
																						<stop
																							offset="95%"
																							stopColor={
																								this
																									.state
																									.shootsGraphData[0]
																									.totalEvents >=
																								this
																									.state
																									.shootsGraphData[2]
																									.totalEvents
																									? '#B83D44'
																									: '#559F7B'
																							}
																							stopOpacity={
																								0
																							}
																						/>
																					</linearGradient>
																				</defs>
																				<XAxis
																					dataKey="date"
																					tick={
																						<CustomizedAxisTick
																							type={
																								'x'
																							}
																						/>
																					}
																				></XAxis>
																				<YAxis
																					tick={
																						<CustomizedAxisTick
																							type={
																								'y'
																							}
																						/>
																					}
																				/>

																				<Tooltip
																					wrapperStyle={{
																						backgroundColor:
																							'#707070',
																					}}
																					itemStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																					}}
																					labelStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																						color: '#333',
																					}}
																				/>

																				<Area
																					type="monotone"
																					dataKey="totalEvents"
																					stroke={
																						this.state
																							.shootsGraphData[0]
																							.totalEvents >
																						this.state
																							.shootsGraphData[2]
																							.totalEvents
																							? '#B83D44'
																							: '#559F7B'
																					}
																					fillOpacity={1}
																					fill="url(#colorUv2)"
																					name="Total Events"
																				/>
																			</AreaChart>
																		</div>
																	</div>
																</div>
															</div>
															<div className="right-graph-section">
																<div className="proposal-graphs5">
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '15px',
																		}}
																	>
																		<div
																			style={{
																				display: 'flex',
																				flexDirection:
																					'column',
																				gap: '16px',
																			}}
																		>
																			<p
																				style={{
																					color: 'white',
																					// marginLeft: '14px',
																					fontSize:
																						'12px',
																					fontWeight:
																						'400',
																				}}
																			>
																				Shoot Days
																			</p>

																			<p className="graph-text">
																				{_.sum(
																					this.state.shoootDaysGraphData.map(
																						(item) =>
																							item.shootDays,
																					),
																				)}
																			</p>
																		</div>
																		<div className="pg-left">
																			<AreaChart
																				syncId="anyId"
																				width={
																					window.innerWidth /
																						3 -
																					165
																				}
																				height={120}
																				data={this.state.shoootDaysGraphData.map(
																					(obj) => ({
																						...obj,
																						date: moment(
																							obj.month,
																							'YYYYMM',
																						).format(
																							'MMM YY',
																						),
																					}),
																				)}
																				margin={{
																					top: 10,
																					right: 30,
																					left: 0,
																					bottom: 0,
																				}}
																			>
																				<defs>
																					<linearGradient
																						id="colorUv3"
																						x1="0"
																						y1="0"
																						x2="0"
																						y2="1"
																					>
																						<stop
																							offset="5%"
																							stopColor={
																								this
																									.state
																									.shootsGraphData[0]
																									.totalEvents >
																								this
																									.state
																									.shootsGraphData[2]
																									.totalEvents
																									? '#B83D44'
																									: '#559F7B'
																							}
																							stopOpacity={
																								0.8
																							}
																						/>
																						<stop
																							offset="95%"
																							stopColor={
																								this
																									.state
																									.shootsGraphData[0]
																									.totalEvents >
																								this
																									.state
																									.shootsGraphData[2]
																									.totalEvents
																									? '#B83D44'
																									: '#559F7B'
																							}
																							stopOpacity={
																								0
																							}
																						/>
																					</linearGradient>
																				</defs>
																				<XAxis
																					dataKey="date"
																					tick={
																						<CustomizedAxisTick
																							type={
																								'x'
																							}
																						/>
																					}
																				></XAxis>
																				<YAxis
																					tick={
																						<CustomizedAxisTick
																							type={
																								'y'
																							}
																						/>
																					}
																				/>

																				<Tooltip
																					wrapperStyle={{
																						backgroundColor:
																							'#707070',
																					}}
																					itemStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																					}}
																					labelStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																						color: '#333',
																					}}
																				/>

																				<Area
																					type="monotone"
																					dataKey="shootDays"
																					stroke={
																						this.state
																							.shootsGraphData[0]
																							.totalEvents >
																						this.state
																							.shootsGraphData[2]
																							.totalEvents
																							? '#B83D44'
																							: '#559F7B'
																					}
																					fillOpacity={1}
																					fill="url(#colorUv3)"
																					name="Shoot Days"
																				/>
																			</AreaChart>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="prod-mid-graph">
															<div className="mid-graph-container">
																<div
																	className="proposal-graphs5"
																	style={
																		{
																			// position: 'fixed',
																		}
																	}
																>
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '15px',
																		}}
																	>
																		<div
																			style={{
																				display: 'flex',
																				alignItems:
																					'center',
																				justifyContent:
																					'space-between',
																			}}
																		>
																			<p className="bar-graph-text">
																				{moment(
																					this.state
																						.monthActiveFilter,
																					'YYYYMMDD',
																				).format(
																					'MMM YYYY',
																				) + ' - Shoots'}
																			</p>
																			<p className="bar-graph-text2">
																				{_.sum(
																					this.state.currentMonthShootData.map(
																						(item) =>
																							item.totalEvents,
																					),
																				) + ' Total Shoots'}
																			</p>
																		</div>

																		<div className="pg-left">
																			<BarChart
																				syncId="anyId"
																				barGap={2}
																				width={
																					window.innerWidth /
																					2
																				}
																				height={120}
																				data={this.state.currentMonthShootData.map(
																					(obj) => ({
																						...obj,
																						date: moment(
																							obj.date.toString(),
																							'YYYYMMDD',
																						).format(
																							'DD',
																						),
																					}),
																				)}
																				margin={{
																					top: 10,
																					right: 30,
																					left: 0,
																					bottom: 0,
																				}}
																				// key={this.state.chartKey1}
																			>
																				<XAxis
																					dataKey="date"
																					tick={
																						<CustomizedAxisTick
																							type={
																								'x'
																							}
																						/>
																					}
																					interval={0}
																				/>
																				<YAxis
																					tick={
																						<CustomizedAxisTick
																							type={
																								'y'
																							}
																						/>
																					}
																				/>
																				<Tooltip
																					wrapperStyle={{
																						backgroundColor:
																							'#707070',
																					}}
																					itemStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																					}}
																					labelStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																						color: '#333',
																					}}
																				/>
																				<Bar
																					dataKey="totalEvents"
																					fill="#5E55E4"
																					name="Shoots"
																				/>
																			</BarChart>
																		</div>
																	</div>
																</div>
															</div>
														</div>

														<div className="prod-bottom-graph-section">
															<div className="left-graph-section">
																<div className="proposal-graphs6">
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '15px',
																		}}
																	>
																		<p className="bar-graph-text">
																			Total Expense
																		</p>
																		<div className="pg-left">
																			{this.state
																				.expenseGraphData && (
																				<AreaChart
																					syncId="anyId"
																					width={
																						window.innerWidth /
																							3 -
																						165
																					}
																					height={120}
																					data={this.state.expenseGraphData.map(
																						(obj) => ({
																							...obj,
																							date: moment(
																								obj.month,
																								'YYYYMM',
																							).format(
																								'MMM YY',
																							),
																						}),
																					)}
																					margin={{
																						top: 10,
																						right: 30,
																						left: 0,
																						bottom: 0,
																					}}
																				>
																					<defs>
																						<linearGradient
																							id="colorUv5"
																							x1="0"
																							y1="0"
																							x2="0"
																							y2="1"
																						>
																							<stop
																								offset="5%"
																								stopColor={
																									this
																										.state
																										.expenseGraphData[0]
																										.totalExpense >=
																									this
																										.state
																										.expenseGraphData[2]
																										.totalExpense
																										? '#B83D44'
																										: '#559F7B'
																								}
																								stopOpacity={
																									0.8
																								}
																							/>
																							<stop
																								offset="95%"
																								stopColor={
																									this
																										.state
																										.expenseGraphData[0]
																										.totalExpense >=
																									this
																										.state
																										.expenseGraphData[2]
																										.totalExpense
																										? '#B83D44'
																										: '#559F7B'
																								}
																								stopOpacity={
																									0
																								}
																							/>
																						</linearGradient>
																					</defs>
																					<XAxis
																						dataKey="date"
																						tick={
																							<CustomizedAxisTick
																								type={
																									'x'
																								}
																							/>
																						}
																					></XAxis>
																					<YAxis
																						tick={
																							<CustomizedAxisTick
																								type={
																									'y'
																								}
																							/>
																						}
																					/>

																					<Tooltip
																						wrapperStyle={{
																							backgroundColor:
																								'#707070',
																						}}
																						itemStyle={{
																							fontFamily:
																								'Inter',
																							fontSize: 11,
																						}}
																						labelStyle={{
																							fontFamily:
																								'Inter',
																							fontSize: 11,
																							color: '#333',
																						}}
																					/>

																					<Area
																						type="monotone"
																						dataKey="totalExpense"
																						stroke={
																							this
																								.state
																								.expenseGraphData[0]
																								.totalExpense >=
																							this
																								.state
																								.expenseGraphData[2]
																								.totalExpense
																								? '#B83D44'
																								: '#559F7B'
																						}
																						fillOpacity={
																							1
																						}
																						fill="url(#colorUv5)"
																						name="Expenses"
																					/>
																				</AreaChart>
																			)}
																		</div>
																	</div>
																</div>
															</div>
															<div className="right-graph-section">
																<div className="proposal-graphs5">
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '15px',
																		}}
																	>
																		<p className="bar-graph-text">
																			Feedback Collected
																		</p>
																		<div className="pg-left">
																			<AreaChart
																				syncId="anyId"
																				width={
																					window.innerWidth /
																						3 -
																					165
																				}
																				height={120}
																				data={this.state.feedBackGraphData.map(
																					(obj) => ({
																						...obj,
																						date: moment(
																							obj.month,
																							'YYYYMM',
																						).format(
																							'MMM YY',
																						),
																					}),
																				)}
																				margin={{
																					top: 10,
																					right: 30,
																					left: 0,
																					bottom: 0,
																				}}
																				// key={this.state.chartKey1}
																			>
																				<defs>
																					<linearGradient
																						id="colorUv4"
																						x1="0"
																						y1="0"
																						x2="0"
																						y2="1"
																					>
																						<stop
																							offset="5%"
																							stopColor={
																								this
																									.state
																									?.feedBackGraphData[0]
																									.totalFeedBacks >
																								this
																									.state
																									?.feedBackGraphData[2]
																									.totalFeedBacks
																									? '#B83D44'
																									: '#559F7B'
																							}
																							stopOpacity={
																								0.8
																							}
																						/>
																						<stop
																							offset="95%"
																							stopColor={
																								this
																									.state
																									.feedBackGraphData
																									.length >
																									0 &&
																								this
																									.state
																									.feedBackGraphData[0]
																									.totalFeedBacks >
																									this
																										.state
																										.feedBackGraphData[2]
																										.totalFeedBacks
																									? '#B83D44'
																									: '#559F7B'
																							}
																							stopOpacity={
																								0
																							}
																						/>
																					</linearGradient>
																				</defs>
																				<XAxis
																					dataKey="date"
																					tick={
																						<CustomizedAxisTick
																							type={
																								'x'
																							}
																						/>
																					}
																				></XAxis>
																				<YAxis
																					tick={
																						<CustomizedAxisTick
																							type={
																								'y'
																							}
																						/>
																					}
																				/>

																				<Tooltip
																					wrapperStyle={{
																						backgroundColor:
																							'#707070',
																					}}
																					itemStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																					}}
																					labelStyle={{
																						fontFamily:
																							'Inter',
																						fontSize: 11,
																						color: '#333',
																					}}
																				/>

																				<Area
																					type="monotone"
																					dataKey="totalFeedBacks"
																					stroke={
																						this.state
																							.feedBackGraphData[0]
																							.totalFeedBacks >
																						this.state
																							.feedBackGraphData[2]
																							.totalFeedBacks
																							? '#B83D44'
																							: '#559F7B'
																					}
																					fillOpacity={1}
																					fill="url(#colorUv4)"
																					name="Feedbacks"
																				/>
																			</AreaChart>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="prod-mid-graph">
															<div className="mid-graph-container2">
																<div
																	style={{
																		height: '300px',
																		width: '900px',
																		maarginTop: '-24px',
																	}}
																>
																	<div
																		style={{
																			height: '300px',
																			width: '900px',
																		}}
																	>
																		<div
																			style={{
																				display: 'flex',
																				justifyContent:
																					'space-between',
																			}}
																		>
																			<p
																				className="bar-graph-text"
																				style={{
																					marginTop:
																						'16px',
																				}}
																			>
																				{moment(
																					this.state
																						.monthActiveFilter,
																					'YYYYMMDD',
																				).format(
																					'MMM YYYY',
																				) + ' - Clients'}
																			</p>
																		</div>

																		<Doughnut
																			data={
																				this.state.chartData
																			}
																			options={{
																				// ... (your other chart options here)
																				plugins: {
																					legend: {
																						position:
																							'right', // Move the legend to the right side of the chart
																					},
																				},
																				elements: {
																					arc: {
																						borderWidth: 0, // Set the borderWidth to 0 to remove the border from the doughnut segments
																					},
																				},
																			}}
																		/>
																	</div>
																</div>
															</div>
														</div>
													</>
												)}
											{this.state.showEmployeeDetails && (
												<>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Display Name*{' '}
																</label>
																<input
																	type="text"
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	value={this.state.displayName}
																	// name={'personalPhoneNumber'}
																	onChange={(e) => {
																		this.setState({
																			displayName:
																				e.target.value,
																		});
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Full Name*
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	type="text"
																	class="input-field2"
																	placeholder=" "
																	required
																	value={this.state.fullName}
																	onChange={(e) => {
																		this.setState({
																			fullName:
																				e.target.value,
																		});
																	}}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Employment ID
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	type="text"
																	class="input-field2"
																	value={this.state.employeeId2}
																	// name={'officePhoneNumber'}
																	placeholder=" "
																	onChange={(e) => {
																		this.setState({
																			employeeId2:
																				e.target.value,
																		});
																	}}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Gender*
																</label>
																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	required
																	value={this.state.genderType}
																	// onChange={this.handleChange.bind(this)}
																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={
																		this.state.genderOptions
																	}
																	onChange={(e) => {
																		this.setState({
																			// name: e.label,
																			gender: e.value,
																			genderType: e,
																		});
																	}}
																	// defaultValue={
																	// 	_.filter(this.state.workspacesOptions, {
																	// 		value: this.state.createShootWorkspace,
																	// 	})[0]
																	// }
																	// value={this.state.id}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Date of Birth*
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	type="date"
																	class="input-field2"
																	value={this.state.selectedDob}
																	onChange={(e) => {
																		this.setState({
																			selectedDob:
																				e.target.value,
																			dob: parseInt(
																				moment(
																					e.target.value,
																				).format(
																					'YYYYMMDD',
																				),
																			),
																		});
																		console.log(
																			parseInt(
																				moment(
																					e.target.value,
																				).format(
																					'YYYYMMDD',
																				),
																			),
																		);
																	}}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Blood Group
																</label>
																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	required
																	value={
																		this.state
																			.selectedBloodGroup
																	}
																	// onChange={this.handleChange.bind(this)}

																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={
																		this.state.bloodGroupOptions
																	}
																	onChange={(e) => {
																		this.setState({
																			// name: e.label,
																			bloodGroup: e.value,
																			selectedBloodGroup: e,
																		});
																	}}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Aadhar Details*
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	type="text"
																	class="input-field2"
																	value={this.state.aadharNumber}
																	onChange={(e) =>
																		this.setState({
																			aadharNumber:
																				e.target.value,
																		})
																	}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	PAN Details*
																</label>

																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state
																			.showEmployeeDetails
																	}
																	type="text"
																	class="input-field2"
																	value={this.state.panNumber}
																	onChange={(e) =>
																		this.setState({
																			panNumber:
																				e.target.value,
																		})
																	}
																/>
															</div>
														</div>
													</div>
												</>
											)}
											{this.state.showAsset &&
											this.state.assets != null &&
											this.state.assets.length > 0 ? (
												<>
													{this.state.assets.map((el) => {
														return (
															<>
																<div className="input-sec">
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '8px',
																			fontWeight: '400',
																			fontSize: '13px',
																			width: '45%',
																		}}
																	>
																		<div class="input-container2">
																			<label class="label2">
																				Asset Type{' '}
																			</label>
																			<input
																				disabled={
																					this.state
																						.editButtonClk ===
																						false &&
																					this.state
																						.showAsset
																				}
																				className="input-field2"
																				type="text"
																				value={
																					_.size(
																						_.filter(
																							this
																								.state
																								.assetTypeOptions,
																							{
																								value: el.type,
																							},
																						),
																					) > 0
																						? _.filter(
																								this
																									.state
																									.assetTypeOptions,
																								{
																									value: el.type,
																								},
																						  )[0][
																								'label'
																						  ]
																						: el.type
																				}
																			/>
																		</div>
																	</div>
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '8px',
																			fontWeight: '400',
																			fontSize: '13px',
																			width: '45%',
																		}}
																	>
																		<div class="input-container2">
																			<label class="label2">
																				QR Code
																			</label>
																			<input
																				disabled={
																					this.state
																						.editButtonClk ===
																						false &&
																					this.state
																						.showAsset
																				}
																				type="text"
																				className="input-field2"
																				value={el.qrCode}
																			/>
																		</div>
																	</div>
																</div>
																<div className="input-sec">
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '8px',
																			fontWeight: '400',
																			fontSize: '13px',
																			width: '45%',
																		}}
																	>
																		<div class="input-container2">
																			<label class="label2">
																				Serial Number{' '}
																			</label>
																			<input
																				disabled={
																					this.state
																						.editButtonClk ===
																						false &&
																					this.state
																						.showAsset
																				}
																				className="input-field2"
																				type="text"
																				value={
																					el.serialNumber
																				}
																			/>
																		</div>
																	</div>
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '8px',
																			fontWeight: '400',
																			fontSize: '13px',
																			width: '45%',
																		}}
																	>
																		<div
																			style={{
																				backgroundColor:
																					'#C43535',
																				cursor: 'pointer',
																				width: '97px',
																				height: '73px',
																				display: 'flex',
																				alignItems:
																					'center',
																				justifyContent:
																					'center',
																				borderRadius: '4px',
																				// marginLeft: '64px',
																			}}
																			onClick={() => {
																				let id = el.qrCode
																					? el.qrCode
																					: el.serialNumber;
																				console.log(
																					'del id',
																					id,
																				);
																				this.deleteAssetAPICall(
																					id,
																				);
																			}}
																		>
																			<Delete
																				style={{
																					height: '24px',
																					width: '24px',
																				}}
																			/>
																		</div>
																	</div>
																</div>
																<div
																	style={{
																		borderBottom:
																			'1px solid #6E6E6E',
																		width: 'calc(100% + 47px)',
																		marginLeft: '-24px',
																		marginBottom: '20px',
																	}}
																></div>
															</>
														);
													})}
												</>
											) : (
												<></>
											)}
											{(this.state.showAsset && this.state.assets === null) ||
											(this.state.showAsset &&
												this.state.assets.length === 0) ? (
												<>
													<div
														style={{
															width: '100%',
															// padding: '31px 24px',
															// background: '#000000',
															height: '192px',
															backgroundColor: '#272727',
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
														}}
													>
														<p
															style={{
																color: '#B0B0B0',
																fontSize: '16px',
																fontWeight: '400',
																lineHeight: '24px',
															}}
														>
															No Asset Assigned
														</p>
													</div>
												</>
											) : (
												<></>
											)}

											{this.state.showEmployment && (
												<>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Joining Date{' '}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	type="date"
																	value={
																		this.state
																			.selectedJoiningDate
																	}
																	onChange={(e) =>
																		this.setState({
																			selectedJoiningDate:
																				e.target.value,
																			joiningDate: parseInt(
																				moment(
																					e.target.value,
																				).format(
																					'YYYYMMDD',
																				),
																			),
																		})
																	}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">Type</label>
																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	required
																	value={
																		this.state
																			.employeeTypeSelect
																	}
																	// onChange={this.handleChange.bind(this)}
																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={
																		this.state.empTypeOptions
																	}
																	onChange={(e) => {
																		this.setState({
																			// name: e.label,
																			employeeType: e.value,
																			employeeTypeSelect: e,
																		});
																	}}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">Brand</label>
																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	required
																	value={this.state.selectedBrand}
																	// onChange={this.handleChange.bind(this)}
																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={
																		this.state.workspaceOptions
																	}
																	onChange={(e) => {
																		this.setState({
																			// name: e.label,
																			brandString: e.value,
																			selectedBrand: e,
																		});
																	}}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Department
																</label>

																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	required
																	value={
																		this.state
																			.selectedDepartment
																	}
																	// onChange={this.handleChange.bind(this)}
																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={this.state.departments}
																	onChange={(e) => {
																		this.setState({
																			// name: e.label,
																			selectedDepartment: e,
																			department: e.value,
																		});
																	}}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Designation{' '}
																</label>
																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	required
																	value={
																		this.state
																			.selectedDesignation
																	}
																	// onChange={this.handleChange.bind(this)}
																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={
																		this.state.designations
																	}
																	onChange={(e) => {
																		this.setState({
																			// name: e.label,
																			designation: e.value,
																			selectedDesignation: e,
																		});
																	}}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Monthly Salary
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	type="number"
																	className="input-field2"
																	value={
																		this.state
																			.monthlySalaryPreTax
																	}
																	onChange={(e) =>
																		this.setState({
																			monthlySalaryPreTax:
																				e.target.value,
																		})
																	}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Branch*{' '}
																</label>
																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	required
																	value={
																		this.state.selectedBranch
																	}
																	// onChange={this.handleChange.bind(this)}
																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={
																		this.state.branchesOptions
																	}
																	onChange={(e) => {
																		this.setState({
																			branchIdString: e.label,
																			branchId: e.value,
																			selectedBranch: e,
																		});
																		console.log(
																			'debugging branch====>',
																			this.state.branchId,
																			this.state
																				.branchIdString,
																		);
																	}}
																	// defaultValue={
																	// 	_.filter(this.state.workspacesOptions, {
																	// 		value: this.state.createShootWorkspace,
																	// 	})[0]
																	// }
																	// value={this.state.id}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">Status</label>
																<Select
																	isDisabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showEmployment
																	}
																	required
																	value={
																		this.state.selectedStatus
																	}
																	// onChange={this.handleChange.bind(this)}
																	className="input-field2 cost-select-container2"
																	classNamePrefix="cost-select"
																	options={
																		this.state.statusOptions
																	}
																	onChange={(e) => {
																		this.setState({
																			statusString: e.value,
																			selectedStatus: e,
																		});
																	}}
																	isSearchable={true}
																	menuPortalTarget={document.body}
																	menuPosition={'fixed'}
																/>
															</div>
														</div>
													</div>
												</>
											)}
											{this.state.showContact && (
												<>
													<div
														className="input-sec"
														style={
															{
																// marginTop: '-16px',
															}
														}
													>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Phone Number*{' '}
																	{this.state
																		.personalPhoneNumber &&
																	this.state
																		.personalPhoneNumberError &&
																	this.state.personalPhoneNumber
																		.length > 0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Wrong format for Phone
																			Number
																		</span>
																	) : this.state
																			.personalPhoneNumber !==
																			null &&
																	  this.state
																			.personalPhoneNumberError &&
																	  this.state.personalPhoneNumber
																			.length === 0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Required
																		</span>
																	) : (
																		<></>
																	)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state
																			.personalPhoneNumber
																	}
																	name={'personalPhoneNumber'}
																	onChange={(e) =>
																		this.handleOnChange(e)
																	}
																	onBlur={(e) => {
																		if (
																			!validator.isMobilePhone(
																				e.target.value,
																				'en-IN',
																			)
																		) {
																			this.setState({
																				personalPhoneNumberError: true,
																			});
																		} else {
																			this.setState({
																				personalPhoneNumberError: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Email Address*{' '}
																	{this.state.personalEmail &&
																	this.state.personalEmailError &&
																	this.state.personalEmail
																		.length > 0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Wrong email format
																		</span>
																	) : this.state.personalEmail !==
																			null &&
																	  this.state
																			.personalEmailError &&
																	  this.state.personalEmail
																			.length === 0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Required
																		</span>
																	) : (
																		<></>
																	)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={this.state.personalEmail}
																	onChange={(e) => {
																		this.setState({
																			personalEmail:
																				e.target.value,
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			!validator.isEmail(
																				e.target.value,
																			)
																		) {
																			this.setState({
																				personalEmailError: true,
																			});
																		} else {
																			this.setState({
																				personalEmailError: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
													<div
														className="input-sec"
														style={
															{
																//marginTop: '-16px',
															}
														}
													>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Office Phone Number{' '}
																	{this.state.officePhoneNumber &&
																	this.state
																		.officePhoneNumberError &&
																	this.state.officePhoneNumber
																		.length > 0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Wrong format for Phone
																			Number
																		</span>
																	) : (
																		<></>
																	)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.officePhoneNumber
																	}
																	name={'officePhoneNumber'}
																	onChange={(e) =>
																		this.handleOnChange(e)
																	}
																	onBlur={(e) => {
																		if (
																			!validator.isMobilePhone(
																				e.target.value,
																				'en-IN',
																			)
																		) {
																			this.setState({
																				officePhoneNumberError: true,
																			});
																		} else {
																			this.setState({
																				officePhoneNumberError: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Office Email Address{' '}
																	{this.state.officeEmail &&
																	this.state.officeEmailError &&
																	this.state.officeEmail.length >
																		0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Wrong email format
																		</span>
																	) : (
																		<></>
																	)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={this.state.officeEmail}
																	onChange={(e) => {
																		this.setState({
																			officeEmail:
																				e.target.value,
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			!validator.isEmail(
																				e.target.value,
																			)
																		) {
																			this.setState({
																				officeEmailError: true,
																			});
																		} else {
																			this.setState({
																				officeEmailError: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
													<div className="input-sec" style={{}}>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Emergency Contact Number*{' '}
																	{this.state.emergencyContact
																		.phoneNumber &&
																	this.state
																		.emergencyContactError &&
																	this.state.emergencyContact
																		.phoneNumber.length > 0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Wrong format for Phone
																			Number
																		</span>
																	) : this.state.emergencyContact
																			.phoneNumber !== null &&
																	  this.state
																			.emergencyContactError &&
																	  this.state.emergencyContact
																			.phoneNumber.length ===
																			0 ? (
																		<span
																			style={{
																				color: 'red',
																				marginLeft: '6px',
																			}}
																		>
																			Required
																		</span>
																	) : (
																		<></>
																	)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.emergencyContact
																			.phoneNumber
																	}
																	onChange={(e) => {
																		this.setState({
																			emergencyContact: {
																				...this.state
																					.emergencyContact,
																				phoneNumber:
																					e.target.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			!validator.isMobilePhone(
																				e.target.value,
																				'en-IN',
																			)
																		) {
																			this.setState({
																				emergencyContactError: true,
																			});
																		} else {
																			this.setState({
																				emergencyContactError: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Emergency Contact Name*{' '}
																	{this.state.emergencyContact
																		.name !== null &&
																		this.state
																			.emergencyNameError &&
																		this.state.emergencyContact
																			.name.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.emergencyContact
																			.name
																	}
																	onChange={(e) => {
																		this.setState({
																			emergencyContact: {
																				...this.state
																					.emergencyContact,
																				name: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				emergencyNameError: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				emergencyNameError: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Emergency Relation Name{' '}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.emergencyContact
																			.relation
																	}
																	onChange={(e) => {
																		this.setState({
																			emergencyContact: {
																				...this.state
																					.emergencyContact,
																				relation:
																					e.target.value,
																			},
																		});
																	}}
																	class="input-field2"
																	placeholder=" "
																/>
															</div>
														</div>
													</div>
													<p
														style={{
															fontSize: '16px',
															fontWeight: '500',
															color: '#FFFFFF',
															marginBottom: '16px',
														}}
													>
														Current Address
													</p>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	City*{' '}
																	{this.state.currentAddress
																		.city !== null &&
																		this.state.curcityEr &&
																		this.state.currentAddress
																			.city.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.currentAddress
																			.city
																	}
																	onChange={(e) => {
																		this.setState({
																			currentAddress: {
																				...this.state
																					.currentAddress,
																				city: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				curcityEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				curcityEr: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Country*
																	{this.state.currentAddress
																		.country !== null &&
																		this.state.curcountryEr &&
																		this.state.currentAddress
																			.country.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.currentAddress
																			.country
																	}
																	onChange={(e) => {
																		this.setState({
																			currentAddress: {
																				...this.state
																					.currentAddress,
																				country:
																					e.target.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				curcountryEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				curcountryEr: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	District*{' '}
																	{this.state.currentAddress
																		.district !== null &&
																		this.state.curDistrictEr &&
																		this.state.currentAddress
																			.district.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.currentAddress
																			.district
																	}
																	onChange={(e) => {
																		this.setState({
																			currentAddress: {
																				...this.state
																					.currentAddress,
																				district:
																					e.target.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				curDistrictEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				curDistrictEr: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Pincode*
																	{this.state.currentAddress
																		.pinCode !== null &&
																		this.state.curPcEr &&
																		this.state.currentAddress
																			.pinCode.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="number"
																	value={
																		this.state.currentAddress
																			.pinCode
																	}
																	onChange={(e) => {
																		this.setState({
																			currentAddress: {
																				...this.state
																					.currentAddress,
																				pinCode: parseInt(
																					e.target.value,
																				),
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				curPcEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				curPcEr: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	State*
																	{this.state.currentAddress
																		.state !== null &&
																		this.state.curStateEr &&
																		this.state.currentAddress
																			.state.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.currentAddress
																			.state
																	}
																	onChange={(e) => {
																		this.setState({
																			currentAddress: {
																				...this.state
																					.currentAddress,
																				state: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				curStateEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				curStateEr: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Street*
																	{this.state.currentAddress
																		.street !== null &&
																		this.state.curStreetEr &&
																		this.state.currentAddress
																			.street.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.currentAddress
																			.street
																	}
																	onChange={(e) => {
																		this.setState({
																			currentAddress: {
																				...this.state
																					.currentAddress,
																				street: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				curStateEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				curStateEr: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
													<p
														style={{
															fontSize: '16px',
															fontWeight: '500',
															color: '#FFFFFF',
															marginBottom: '16px',
														}}
													>
														Permanent Address
													</p>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	City*
																	{this.state.permanentAddress
																		.city !== null &&
																		this.state.percityEr &&
																		this.state.permanentAddress
																			.city.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.permanentAddress
																			.city
																	}
																	onChange={(e) => {
																		this.setState({
																			permanentAddress: {
																				...this.state
																					.permanentAddress,
																				city: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				percityEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				percityEr: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Country*{' '}
																	{this.state.permanentAddress
																		.country !== null &&
																		this.state.percountryEr &&
																		this.state.permanentAddress
																			.country.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}{' '}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.permanentAddress
																			.country
																	}
																	onChange={(e) => {
																		this.setState({
																			permanentAddress: {
																				...this.state
																					.permanentAddress,
																				country:
																					e.target.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				percountryEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				percountryEr: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	District*{' '}
																	{this.state.permanentAddress
																		.district !== null &&
																		this.state.perDistrictEr &&
																		this.state.permanentAddress
																			.district.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.permanentAddress
																			.district
																	}
																	onChange={(e) => {
																		this.setState({
																			permanentAddress: {
																				...this.state
																					.permanentAddress,
																				district:
																					e.target.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				perDistrictEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				perDistrictEr: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Pincode*
																	{this.state.permanentAddress
																		.pinCode !== null &&
																		this.state.perPcEr &&
																		this.state.permanentAddress
																			.pinCode.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="number"
																	value={
																		this.state.permanentAddress
																			.pinCode
																	}
																	onChange={(e) => {
																		this.setState({
																			permanentAddress: {
																				...this.state
																					.permanentAddress,
																				pinCode: parseInt(
																					e.target.value,
																				),
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				perPcEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				perPcEr: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	State*
																	{this.state.permanentAddress
																		.state !== null &&
																		this.state.perStateEr &&
																		this.state.permanentAddress
																			.state.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.permanentAddress
																			.state
																	}
																	onChange={(e) => {
																		this.setState({
																			permanentAddress: {
																				...this.state
																					.permanentAddress,
																				state: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				perStateEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				perStateEr: false,
																			});
																		}
																	}}
																	class="input-field2"
																	placeholder=" "
																	// required
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Street*{' '}
																	{this.state.permanentAddress
																		.street !== null &&
																		this.state.perStreetEr &&
																		this.state.permanentAddress
																			.street.length ===
																			0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showContact
																	}
																	type="text"
																	value={
																		this.state.permanentAddress
																			.street
																	}
																	onChange={(e) => {
																		this.setState({
																			permanentAddress: {
																				...this.state
																					.permanentAddress,
																				street: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				perStreetEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				perStreetEr: false,
																			});
																		}
																	}}
																	className="input-field2"
																/>
															</div>
														</div>
													</div>
												</>
											)}
											{this.state.showBank && (
												<>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Bank Account Number*{' '}
																	{this.state.bankAccountDetails
																		.accountNumber !== null &&
																		this.state
																			.bankAccNumberError &&
																		this.state
																			.bankAccountDetails
																			.accountNumber
																			.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showBank
																	}
																	className="input-field2"
																	type="text"
																	value={
																		this.state
																			.bankAccountDetails
																			.accountNumber
																	}
																	onChange={(e) => {
																		this.setState({
																			bankAccountDetails: {
																				...this.state
																					.bankAccountDetails,
																				accountNumber:
																					e.target.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				bankAccNumberError: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				bankAccNumberError: false,
																			});
																		}
																	}}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	IFSC Code*
																	{this.state.bankAccountDetails
																		.IFSC !== null &&
																		this.state.bankifscEr &&
																		this.state
																			.bankAccountDetails.IFSC
																			.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showBank
																	}
																	type="text"
																	className="input-field2"
																	value={
																		this.state
																			.bankAccountDetails.IFSC
																	}
																	onChange={(e) => {
																		this.setState({
																			bankAccountDetails: {
																				...this.state
																					.bankAccountDetails,
																				IFSC: e.target
																					.value,
																			},
																		});
																	}}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				bankifscEr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				bankifscEr: false,
																			});
																		}
																	}}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Beneficiary Name*{' '}
																	{this.state.bankAccountDetails
																		.accountHolderName !==
																		null &&
																		this.state.bankAccHolErr &&
																		this.state
																			.bankAccountDetails
																			.accountHolderName
																			.length === 0 && (
																			<span
																				style={{
																					color: 'red',
																					marginLeft:
																						'6px',
																				}}
																			>
																				Required
																			</span>
																		)}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showBank
																	}
																	className="input-field2"
																	type="text"
																	value={
																		this.state
																			.bankAccountDetails
																			.accountHolderName
																	}
																	onBlur={(e) => {
																		if (
																			e.target.value
																				.length === 0
																		) {
																			this.setState({
																				bankAccHolErr: true,
																			});
																		} else if (
																			e.target.value.length >
																			0
																		) {
																			this.setState({
																				bankAccHolErr: false,
																			});
																		}
																	}}
																	onChange={(e) => {
																		this.setState({
																			bankAccountDetails: {
																				...this.state
																					.bankAccountDetails,
																				accountHolderName:
																					e.target.value,
																			},
																		});
																	}}
																/>
															</div>
														</div>
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Bank Name{' '}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showBank
																	}
																	className="input-field2"
																	type="text"
																	value={
																		this.state
																			.bankAccountDetails
																			.bankName
																	}
																	onChange={(e) => {
																		this.setState({
																			bankAccountDetails: {
																				...this.state
																					.bankAccountDetails,
																				bankName:
																					e.target.value,
																			},
																		});
																	}}
																/>
															</div>
														</div>
													</div>
													<div className="input-sec">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																fontWeight: '400',
																fontSize: '13px',
																width: '45%',
															}}
														>
															<div class="input-container2">
																<label class="label2">
																	Branch{' '}
																</label>
																<input
																	disabled={
																		this.state.editButtonClk ===
																			false &&
																		this.state.showBank
																	}
																	className="input-field2"
																	type="text"
																	value={
																		this.state
																			.bankAccountDetails
																			.branch
																	}
																	onChange={(e) => {
																		this.setState({
																			bankAccountDetails: {
																				...this.state
																					.bankAccountDetails,
																				branch: e.target
																					.value,
																			},
																		});
																	}}
																/>
															</div>
														</div>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
				<Modal
					handleClose={() => this.showUploadLogoModal()}
					show={this.state.showUploadLogoModal}
					modalType={'center'}
				>
					<UploadLogoForm
						{...this.props}
						imageSrc={this.state.imageSrc}
						addEmployeeId={this.state.addEmployeeId}
						files={this.state.files}
						imageHeight={this.state.imageHeight}
						imageWidth={this.state.imageWidth}
						close={() => this.showUploadLogoModal()}
						onLogoUpdated={() => this.onLogoUpdated()}
						imgCrop={(img) => {
							this.imgCrop(img);
						}}
					/>
				</Modal>
				{this.state.showAssetModal ? (
					<AssignAsset
						handleClose={() => {
							this.setState({
								showAssetModal: false,
							});
						}}
						employee={{ _id: this.state.employeeId, name: this.state.fullName }}
						show={this.state.showAssetModal}
						close={() => {
							this.setState({
								showAssetModal: false,
							});
						}}
					/>
				) : null}
			</div>
		);
	}
}
export default withRouter(EmployeeDetails);
class CustomizedAxisTick extends Component {
	render() {
		const { x, y, stroke, payload } = this.props;

		return (
			<g transform={`translate(${x},${y})`}>
				<text
					x={0}
					y={0}
					dy={this.props.type === 'x' ? 16 : 4}
					dx={this.props.type === 'x' ? 24 : 0}
					textAnchor="end"
					fill="#666"
					class={'small'}
				>
					{payload.value}
				</text>
			</g>
		);
	}
}
